import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../page-layout/page-data-panel.component';
import { AuditActorSummary, AuditTimelineEvent } from './audit.models';

@Component({
    selector: 'app-audit-timeline',
    standalone: true,
    imports: [CommonModule, TableModule, TagModule, PageDataPanelComponent],
    template: `
        <app-page-data-panel [title]="title" [resultText]="events.length + ' events'">
            <p-table [value]="events" responsiveLayout="stack">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Event</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Actor</th>
                        <th>Source</th>
                        <th>When</th>
                        <th>Reason</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-event>
                    <tr>
                        <td><p-tag [value]="event.eventType || 'EVENT'" severity="info"></p-tag></td>
                        <td>{{ event.fromStatus || '-' }}</td>
                        <td>{{ event.toStatus || '-' }}</td>
                        <td>{{ actorLabel(event.actor, event.actorName, event.actorId) }}</td>
                        <td>{{ event.source || '-' }}</td>
                        <td>{{ event.createdAt | date:'short' }}</td>
                        <td>{{ event.comment || '-' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" class="empty-cell">No audit events are available.</td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    `,
    styles: [`.empty-cell { padding: 1rem; text-align: center; color: #64748b; }`],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditTimelineComponent {
    @Input() title = 'Activity Timeline';
    @Input() events: AuditTimelineEvent[] = [];

    actorLabel(actor?: AuditActorSummary | null, legacyName?: string | null, actorId?: number | string | null): string {
        if (actor?.name) {
            return actor.id ? `${actor.name} (#${actor.id})` : actor.name;
        }
        if (legacyName) {
            return legacyName;
        }
        if (actorId !== null && actorId !== undefined && actorId !== '') {
            return `#${actorId}`;
        }
        return 'System';
    }
}
